var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.04 55.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7d5d5;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-2{font-size:38px;fill:#fff;font-family:MuktaMahee-Regular, Mukta Mahee;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:-0.02em;}.cls-5{fill:#56b2b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.16,
    y: 0.5,
    width: 237.38,
    height: 43.88
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(101.47 34.35)"
  }, "GE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.52,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 61.14,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.42,
    y: 0
  }, "ORE")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 8.01,
    cy: 21.1,
    r: 8.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 34.51,
    cy: 21.1,
    r: 8.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 59.02,
    cy: 21.1,
    r: 8.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestore);
export default __webpack_public_path__ + "static/media/gestore.79b6b2910b3618125719fa97cee58902.svg";
export { ForwardRef as ReactComponent };